import { POST_EXTRA_HOURS_SUCCESS, POST_EXTRA_HOURS_FAILURE } from "../constants/MyM";

const initStat = { data: [], error: false, errorData: "", isLoading: true };

export default (state = initStat, action) => {
  switch (action.type) {
    case POST_EXTRA_HOURS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };
    case POST_EXTRA_HOURS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorData: action.payload,
        error: true,
      };
    default:
      return { ...state };
  }
};
